<template>
    <div class="">
        <el-dialog :visible.sync="showModel" :close-on-click-modal="false" :destroy-on-close="true" :before-close='close'
            custom-class="cus_dialog cus_dialogMax" width="1000px">
            <div slot="title" class="flexBetween">
                <span style="color: #ffffff;"><span style="font-weight: 700">{{ formData.stu_name }}</span> 简历详情</span>
            </div>
            <div class="rowContainer">
                <!--                头像-->
                <div class="item-userinfo flexStart">
                    <div class="avatarContainer flexCenter">
                        <el-image fit="cover" style="width:100px;height:100px;border-radius: 50%;"
                            :src="formData.photo ? formData.photo : url"
                            :preview-src-list="[formData.photo ? formData.photo : url]"></el-image>
                    </div>
                    <div class="right rightRow1 flex_1">
                        <div class="top flexBetweenBottom">
                            <div class="flexLeft">
                                <div style="vertical-align: bottom">
                                    <span class="userName">{{ formData.stu_name || '-' }}</span>
                                    <img v-if="formData.sex == 1" style="width:14px;height:14px;"
                                        src="../../../../public/img/male.png" alt="">
                                    <img v-if="formData.sex == 2" style="width:14px;height:14px;"
                                        src="../../../../public/img/female.png" alt="">
                                </div>
                                <div class="crumbInfo">
                                    <i class="el-icon-message"></i>
                                    <span style="margin-left: 10px">{{ formData.birthday || '-' }}</span>
                                    <el-divider direction="vertical" />

                                    <i class="el-icon-suitcase"></i>

                                    <span style="margin-left: 10px">{{ xlyq[formData.eduaction] || '-' }} · {{
                                        formData.profession_name ||
                                        '-' }}</span>
                                    <el-divider direction="vertical" />

                                    <i class="el-icon-user"></i>

                                    <!--                                    <span class="verticalBorder"></span>-->
                                    <span style="margin-left: 10px">{{ qzzt[formData.job_status] || '-'
                                    }}</span>
                                </div>

                            </div>

                        </div>
                        <div class="contact flexStart">

                            <i class="el-icon-mobile-phone"></i>
                            <span v-if="(pages == 'receive' || formData.yq_status > 0 || formData.invite_status == 1)"
                                class="mosaic" style="margin-left: 10px">{{ formData.tel
                                }}</span>
                            <span v-if="(pages != 'receive' && formData.yq_status <= 0 && formData.invite_status != 1)"
                                class="" style="margin-left: 10px"> ***********</span>
                            <el-divider direction="vertical" />

                            <i class="el-icon-chat-round"></i>

                            <span v-if="(pages == 'receive' || formData.yq_status > 0 || formData.invite_status == 1)"
                                class="mosaic" style="margin-left: 10px">{{ formData.wechat
                                }}</span>
                            <span v-if="(pages != 'receive' && formData.yq_status <= 0 && formData.invite_status != 1)"
                                class="" style="margin-left: 10px">*********</span>
                        </div>
                        <div class="commonText">
                            <span>个人优势：{{ formData.advandage }}</span>
                        </div>
                        <div v-if="(pages == 'receive' || formData.yq_status > 0 || formData.invite_status == 1) && formData.annexes && formData.annexes.length > 0 && formData.annexes[0]"
                            class="annexResume flexStart">
                            <span @click="openAnnexResume(formData.annexes[0])" class="overText" style="cursor:pointer;">
                                <i class="el-icon-paperclip">简历附件</i>
                            </span>
                        </div>
                    </div>
                </div>
                <!--                期望职位-->
                <div v-if="formData.job_array && formData.job_array.length > 0" class="item-userinfo flexStartUp">
                    <div class="left">
                        <div class="flexEnd">
                            <span class="color60 fontWeight500">期望职位</span>
                        </div>
                    </div>
                    <div class="right rightRow2 flex_1">
                        <div v-for="(item, index) in formData.job_array" class="crumbInfo">
                            {{ index + 1 }}.
                            <span>{{ item.type_name || '-' }}</span>
                            <el-divider direction="vertical" />

                            <span>{{ item.cityName || '-' }}</span>
                            <el-divider direction="vertical" />

                            <!-- <span>{{ item.expectJob.industry || '-' }}</span> -->
                            <!-- <el-divider direction="vertical" /> -->

                            <span>{{ item.pay == 0 ? '面议' : (xzfw[item.pay] || '-') }}</span>
                        </div>
                    </div>
                </div>
                <!--                教育经历-->
                <div v-if="false" class="item-userinfo flexStartUp">
                    <div class="left" :span="5">
                        <div class="flexEnd">
                            <span class="color30 fontWeight500">教育经历</span>
                        </div>
                    </div>
                    <div class="right color30 flex_1">
                        <div class="flexBetween">
                            <div class="crumbInfo">
                                <span>{{ formData.school_name || '-' }}学校</span>
                                <el-divider direction="vertical" />

                                <span>{{ formData.profession_name || '-' }}专业</span>
                                <el-divider direction="vertical" />

                                <span>{{ xlyq[formData.eduaction] || '-' }}学历</span>
                            </div>
                            <div class="timestamp">{{ formData.leave_time || '-' }}毕业时间</div>
                        </div>
                    </div>
                </div>
                <!--                实践经历-->
                <div class="item-userinfo" v-for="(item, index) in formData.practice" :key="index">
                    <div class="item-userinfo flexStartUp">
                        <div class="left" :span="5">
                            <div class="flexEnd">
                                <span class="color30 fontWeight500">实践经历</span>
                            </div>
                        </div>
                        <div class="right color30 flex_1">
                            <div class="flexBetween">
                                <div class="crumbInfo">
                                    <span>{{ item.enterName || '-' }}</span>
                                    <el-divider direction="vertical" />

                                    <span>{{ item.dept }} · {{ item.job_type_name || '-' }}</span>
                                </div>
                                <div class="timestamp">{{ item.startDate }}~{{ item.endDate }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="item-userinfo subitem-userinfo flexStartUp">
                        <div class="left" :span="5">
                            <div class="flexEnd">
                                <span class="color60">业绩</span>
                            </div>
                        </div>
                        <div class="right color60 flex_1">
                            <span>{{ item.jobContent || '-' }}</span>
                        </div>
                    </div>
                    <div class="item-userinfo subitem-userinfo flexStartUp">
                        <div class="left" :span="5">
                            <div class="flexEnd">
                                <span class="color60">内容</span>
                            </div>
                        </div>
                        <div class="right color60 flex_1">
                            <div>
                                <span>{{ item.perfor || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--                项目经验-->
                <div class="item-userinfo" v-for="(item, index) in formData.project" :key="index + '1'">
                    <div class="item-userinfo flexStartUp">
                        <div class="left" :span="5">
                            <div class="flexEnd">
                                <span class="color30 fontWeight500">项目经验</span>
                            </div>
                        </div>
                        <div class="right color30 flex_1">
                            <div class="flexBetween">
                                <div class="crumbInfo">
                                    <span>{{ item.name || '-' }}</span>
                                    <el-divider direction="vertical" />

                                    <span>{{ item.role || '-' }}</span>
                                </div>
                                <div class="timestamp">{{ item.startDate }}~{{ item.endDate }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="item-userinfo subitem-userinfo flexStartUp">
                        <div class="left" :span="5">
                            <div class="flexEnd">
                                <span class="color60">业绩</span>
                            </div>
                        </div>
                        <div class="right color60 flex_1">
                            <span>{{ item.prefor || '-' }}</span>
                        </div>
                    </div>
                    <div class="item-userinfo subitem-userinfo flexStartUp">
                        <div class="left">
                            <div class="flexEnd">
                                <span class="color60">描述</span>
                            </div>
                        </div>
                        <div class="right color60 flex_1">
                            <div>
                                <span>{{ item.projDesc || '-' }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.annex && item.annex.length > 0" class="item-userinfo subitem-userinfo flexStartUp">
                        <div class="left">
                            <div class="flexEnd">
                                <span class="color60">项目附件</span>
                            </div>
                        </div>
                        <div class="right flex_1">
                            <div class="flexStart" v-for="(att, indexAtt) in item.annex" :key="indexAtt">
                                <span class="overText">{{ att.fileName }}</span>
                                <span class="item-att" @click="openAnnexResume(att)">
                                    <span>查看</span><i class="el-icon-arrow-right"></i>
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
                <!--            获奖证书-->
                <div v-if="formData.award_annex && formData.award_annex.length > 0" class="item-userinfo">
                    <div class="item-userinfo flexStartUp">
                        <div class="left" :span="5">
                            <div class="flexEnd">
                                <span class="color30 fontWeight500">获奖证书</span>
                            </div>
                        </div>
                        <div class="right color30 flex_1">
                            <div class="crumbImg flex_1">

                                <div class="thumbnail" v-for=" (item, index) in formData.award_annex" :key="index"
                                    style="margin-right:10px;">
                                    <el-image style="width: 100%; height: 100%" :src="item.fileUrl"
                                        :preview-src-list="[item.fileUrl]">
                                    </el-image>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div v-if="pages == 'recommend'" slot="footer" class="dialog-footer">
                <!-- <el-button v-if="formData.status == 0" type="primary">邀请简历
                </el-button>
                <el-button v-if="formData.status == 1">已邀请
                </el-button>||||||||||||||||||| -->
                <el-button @click="close" type="primary" plain>{{ formData.invite_status == 1 ? '（已邀请）' : '' }} 关
                    闭</el-button>
                <el-button v-if="formData.invite_status == 0" @click="chakan(formData)" type="primary"
                    icon="el-icon-check">邀请简历</el-button>
            </div>
            <div v-if="pages != 'recommend'" slot="footer" class="dialog-footer">
                <el-button @click="close" type="primary" plain>关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: {
        pages: {
            type: String
        },
        formData: {
            type: Object
        },
        xlyq: {
            type: Object
        },
        xzfw: {
            type: Object
        },
        qzzt: {
            type: Object
        },
    },
    data() {
        return {
            showModel: true,
            url: "./img/img_avatar.png",
        }
    },
    mounted() {

    },
    methods: {
        chakan(e) {
            this.$emit('touch', e)
        },
        openAnnexResume(item) {
            console.log(item)
            this.downloadFile({ fileUrl: (item.url || item.src || item.fileUrl), fileName: item.fileName })
        },
        close() {
            this.$$parent(this, "dialogForm", false);
        }
    },
}

</script>

<style scoped lang="less">
.mosaic {
    position: relative;
    display: inline-block;
    *display: inline;
    *zoom: 1;

    &::before {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        z-index: 2;
        left: 0;
        top: 0;
        background: #fff url(http://ww1.sinaimg.cn/large/7adf23abgy1fcy88c88pkj200t00t0fv) repeat;
        -webkit-background-size: contain;
        background-size: contain;
    }
}

.cus_dialog {

    div {
        box-sizing: border-box;
    }

    .rowContainer {
        width: 100%;

        .item-userinfo {
            margin-top: 32px;

            .color30 {
                color: #303133;
            }

            .color60 {
                color: #606266;
            }

            .fontWeight500 {
                font-weight: 700;
            }

            .left {
                width: 100px;
            }

            .right {
                margin-left: 32px;

                .userName {
                    font-size: 18px;
                    color: #303133;
                    font-weight: 500;
                    margin-right: 4px;
                }

                .contact {
                    margin-top: 8px;
                }

                .timestamp {
                    color: #909399;
                    font-size: 12px;
                }

                .commonText {
                    margin-top: 8px;
                }

                .annexResume {
                    margin-top: 8px;
                    color: #3378fa;
                    cursor: pointer;
                }

                .item-att {
                    margin-left: 8px;
                    color: #3378fa;
                    cursor: pointer;
                }
            }
        }

        .item-userinfo:first-of-type {
            margin-top: 0;
        }

        .subitem-userinfo {
            margin-top: 16px;
            color: #606266;
        }

        .crumbImg {
            width: 100%;

            .thumbnail {
                display: inline-block;
                width: 20%;

                img {
                    display: inline-block;
                    width: 100%;
                }
            }
        }
    }

    .avatarContainer {
        flex: 0 1 68px;

        &>span {
            border-radius: 68px;
            display: block;
            width: 68px;
            height: 68px;
            line-height: 68px;
        }

        .ant-avatar.ant-avatar-icon {
            font-size: 40px;
        }

        img {
            display: inline-block;
            width: 68px;
            height: 68px;
            border-radius: 50%;
        }
    }

    .right {
        .ant-divider-vertical {
            margin: 0 16px;
        }
    }



}
</style>
